import { CSRF_BOOTSTRAP_PATH, readCsrfToken, refreshCsrfCookie } from "./rpc";

export { CSRF_BOOTSTRAP_PATH };

/**
 * The CSRF bootstrap.
 *
 * Every API call is a `POST`, and the server refuses a `POST` that carries no
 * `x-csrf-token` header matching its double-submit cookie
 * (`docs/spec/api-conventions.md` §11). The cookie is minted on the first plain
 * `GET` the browser makes to the server — in production that is the request for
 * the application's own HTML, so the cookie is always there by the time the SPA
 * boots. Behind Vite in development the HTML comes from Vite, not from the
 * server, so the browser may never have made such a request and the very first
 * mutation would be rejected.
 *
 * One `GET /_health` fixes that: it is the cheapest route the server owns, it is
 * proxied to the server like the rest of its surface, and its response sets the
 * cookie. It runs at most once per page load, and only when no cookie is
 * readable, so the production path costs nothing.
 */
let bootstrap: Promise<void> | null = null;

/** Forgets that the bootstrap ran. Exists for tests; nothing else calls it. */
export function resetCsrfBootstrap(): void {
  bootstrap = null;
}

export async function ensureCsrfCookie(): Promise<void> {
  if (readCsrfToken() !== null) return;
  bootstrap ??= refreshCsrfCookie();
  await bootstrap;
}
